import { render, staticRenderFns } from "./test_informacion.vue?vue&type=template&id=57b40211&"
import script from "./test_informacion.vue?vue&type=script&lang=ts&"
export * from "./test_informacion.vue?vue&type=script&lang=ts&"
import style0 from "./test_informacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports